<template>
    <section class="page-section section-cards" :style="{ marginLeft: '5%', height: '100%' }">
        <div class="container">
            <div class="cards-wrapper" :style="{ width: '100%', height: '100%' }">
                <div class="card-element" :style="{ width: '100%', height: '100%' }">
                    <div class="card-wrapper" :style="{ width: '100%', height: '100%' }">
                        <div class="card-content" :style="{ height: '100%', overflow: 'auto' }">
                            <h2>
                                <div v-html="contentTitle" />
                            </h2>
                            <div v-html="contentSentance" class="content-text"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        contentTitle: String,
        contentSentance: String,
        buttonText: String,
        buttonLink: String,
    },
    data() {
        return {
            cards: [],
        };
    },
};
</script>

<style>
@import '@/css/cardSection.css';

.cards-wrapper {
    display: flex;
    align-items: stretch;
    width: 100%;
    height: 32rem;
}

.card-content h2 {
    font-size: 22px;
}

.content-text,
.content-text p {
    font-size: 20px !important;
    font-weight: normal !important;
    letter-spacing: -0.8px;
    line-height: 1.6;
}


</style>
